const PopupButton = require('./menus/Popup');

module.exports = function () {
    document.querySelectorAll('[data-js-popup-button]')
        .forEach(popupButton => new PopupButton(popupButton).init());
};
